// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEmailAttention_root__13HOW","marketplaceStroke":"IconEmailAttention_marketplaceStroke__1pG0o","attentionStroke":"IconEmailAttention_attentionStroke__b2xRm"};